import { gql } from '@apollo/client';

export const GET_QUICKBOOKS_CONNECTION_STATUS = gql`
  query GetQuickBooksConnectionStatus {
    quickBooksConnectionStatus {
      isConnected
      message
      lastCheck
      realmId
      expiresAt
    }
  }
`;

export const GET_QUICKBOOKS_CUSTOMERS = gql`
  query GetQuickBooksCustomers($maxResults: Int, $search: String) {
    quickBooksCustomers(maxResults: $maxResults, search: $search) {
      id
      displayName
      companyName
      givenName
      familyName
      email
      phone
      address
      city
      state
      zip
      active
      balance
    }
  }
`;

export const GET_QUICKBOOKS_CUSTOMER = gql`
  query GetQuickBooksCustomer($id: ID!) {
    quickBooksCustomer(id: $id) {
      id
      displayName
      companyName
      givenName
      familyName
      email
      phone
      address
      city
      state
      zip
      active
      balance
    }
  }
`;

export const GET_QUICKBOOKS_AUTHORIZATION_URL = gql`
  query GetQuickBooksAuthorizationUrl($state: String) {
    quickBooksAuthorizationUrl(state: $state)
  }
`;

export const CONNECT_QUICKBOOKS = gql`
  mutation ConnectQuickBooks($authorizationCode: String!, $realmId: String!) {
    connectQuickBooks(authorizationCode: $authorizationCode, realmId: $realmId)
  }
`;

export const DISCONNECT_QUICKBOOKS = gql`
  mutation DisconnectQuickBooks {
    disconnectQuickBooks
  }
`;

// =====================================================
// QuickBooks Invoice Operations
// =====================================================

/**
 * Validate work orders before creating invoices
 * Returns info about which work orders can be invoiced and any issues
 */
export const VALIDATE_WORK_ORDERS_FOR_INVOICING = gql`
  query ValidateWorkOrdersForInvoicing($workOrderIds: [String!]!) {
    validateWorkOrdersForInvoicing(workOrderIds: $workOrderIds) {
      canCreateInvoices
      validWorkOrderCount
      invalidWorkOrderCount
      alreadyInvoicedCount
      missingCustomerCount
      estimatedTotal
      issues {
        workOrderId
        workOrderNumber
        propertyName
        issue
        issueType
      }
    }
  }
`;

/**
 * Create QuickBooks invoices from work orders
 */
export const GET_PROPERTIES_FOR_QB_ASSIGNMENT = gql`
  query GetPropertiesForQBAssignment($limit: Int!, $offset: Int!, $search: String, $quickbooksFilter: String, $areas: [String!], $propertyManagerId: String, $propertyManagementTeamId: Int) {
    properties(limit: $limit, offset: $offset, search: $search, quickbooksFilter: $quickbooksFilter, areas: $areas, propertyManagerId: $propertyManagerId, propertyManagementTeamId: $propertyManagementTeamId) {
      items {
        id
        name
        area
        quickbooksCustomerId
        isActive
      }
      total
      offset
      limit
    }
  }
`;

export const CREATE_QUICKBOOKS_INVOICES = gql`
  mutation CreateQuickBooksInvoices($input: CreateQuickBooksInvoicesInput!) {
    createQuickBooksInvoices(input: $input) {
      success
      totalInvoicesCreated
      totalWorkOrdersProcessed
      totalAmountInvoiced
      invoices {
        invoiceId
        invoiceNumber
        quickbooksUrl
        customerName
        customerId
        totalAmount
        workOrderIds
        workOrderCount
        propertyName
      }
      errors {
        workOrderId
        message
        code
      }
      warnings {
        workOrderId
        message
        type
      }
    }
  }
`;

